import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Token, LoginData } from 'src/app/auth/models/token.model';
import { ChangePasswordData, CurrentUser } from 'src/app/auth/models/account.model';
import { BackendResponse } from 'src/app/shared/models/backend-response.model';
import { unwrap } from 'src/app/shared/rxjs-operators/unwrap';

@Injectable({ providedIn: 'root' })
export class AccountService {
  http = inject(HttpClient);

  getToken(userName: string, password: string): Observable<Token> {
    return this.http
      .post<LoginData>('Accounts/Token', { userName, password })
      .pipe(map((loginData) => this.loginDataToToken(loginData)));
  }

  refreshToken(refreshToken: string): Observable<Token> {
    return this.http
      .post<LoginData>('Accounts/RefreshToken', { token: refreshToken })
      .pipe(map((loginData) => this.loginDataToToken(loginData)));
  }

  getCurrentUserInfo(): Observable<CurrentUser> {
    return this.http.get<CurrentUser>('Accounts/UserInfo');
  }

  updatePassword(passwords: ChangePasswordData): Observable<void> {
    return this.http.post<BackendResponse<void>>('Accounts/ChangePassword', passwords).pipe(unwrap());
  }

  isExpired(date: string | undefined): boolean {
    return date ? new Date() > new Date(date) : true;
  }

  private loginDataToToken(loginData: LoginData): Token {
    return {
      key: loginData.access_token,
      expiration: loginData.expires,
      refreshToken: loginData.refreshToken,
      refreshTokenExpires: loginData.refreshTokenExpires,
    };
  }
}
